export default __webpack_public_path__ + "static/media/smartplan_navicon.644252e0.svg";